import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledFrequencyNumberInput = styled(NumberInput)`
   width: 70px;
`;

StyledFrequencyNumberInput.displayName = 'StyledFrequencyNumberInput';
